<div class="content">

    <div fxLayout="row" fxLayoutAlign="end" fxLayoutGap="5px">
        <ng-container *ngIf="!isSafari(browserName) && isAdmin">
            <button mat-button color="primary" (click)="importbutton.click();">
                <mat-icon aria-label="">unarchive</mat-icon>{{ 'settingsReportTemplate.import' | translate }}
            </button>
            <input hidden #importbutton type="file" accept=".zip"
                (change)="importReportTemplate($event.target.files, null); importbutton.value=''" />
        </ng-container>
    </div>

    <div *ngIf="reportTemplateFlg" fxLayout="row" fxLayoutGap="5px">
        <mat-table #modeltable [dataSource]="reportTemplatesListDataSource" fxFlex>
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef>{{ 'settingsReportTemplate.templateName' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row">{{ row.name }} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="date">
                <mat-header-cell *matHeaderCellDef>{{ 'settingsReportTemplate.lastUpdateDate' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row">{{ row.lastUpdateDate | date: 'yyyy/MM/dd'}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="subjectModelName">
                <mat-header-cell *matHeaderCellDef>{{ 'settingsReportTemplate.model' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row">{{ row.subjectModelName }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="import">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <ng-container *ngIf="!isSafari(browserName) && isAdmin">
                        <button mat-button color="primary" (click)="importbutton.click();$event.stopPropagation()">
                            <mat-icon aria-label="">unarchive</mat-icon>{{ 'settingsReportTemplate.import' | translate }}
                        </button>
                        <input hidden #importbutton type="file" accept=".zip" (click)="$event.stopPropagation()"
                            (change)="importReportTemplate($event.target.files, row); importbutton.value=''" />
                    </ng-container>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="export">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <ng-container *ngIf="!isSafari(browserName) && isAdmin">
                        <button mat-button color="primary" hidden #importbutton type="file" accept=".zip"
                            (click)="exportReportTemplate(row);$event.stopPropagation()">
                            <mat-icon aria-label="">archive</mat-icon>{{ 'settingsReportTemplate.export' | translate }}
                        </button>
                    </ng-container>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <ng-container>
                        <button mat-button color="warn"
                            (click)="openDeleteDialog(row); $event.stopPropagation()">
                            <mat-icon aria-label="">delete</mat-icon>
                        </button>
                    </ng-container>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row [ngClass]="{ 'editable': isTemplateEditable, 'disabled': isTemplateEditable && !row.isValid }" *matRowDef="let row; columns: displayedColumns;"
                (click)="editReportTemplate(row)"></mat-row>
        </mat-table>
    </div>

    <div *ngIf="!reportTemplateFlg" fxLayout="row" fxLayoutAlign="center none">
        <br>
        <br> {{ 'settingsReportTemplate.reportTemplatesNotFound' | translate }}
    </div>

</div>
